export const frontmatter = {
    "draft": false,
    "title": "Campañas",
    "sidebar_group": "referencia",
    "sidebar_label": "Campañas",
    "sidebar_order": 9
}

export const toc = []